module.exports = __webpack_public_path__ + "static/media/carolina-herrera-its-good-to-be-bad-big.856db16a.png";